import { ExaminationCourseProvider } from '@exam-management/examination-course-details';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useParams } from '@exam-management/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ExamCourseDetailsLayout() {
  const { courseId } = useParams('/exam-courses/:courseId');

  return (
    <ExaminationCourseProvider examCourseId={courseId}>
      <PermissionGuard
        requiredPermission={[
          APP_PERMISSIONS.EXAM.QCONFIG.VIEW,
          APP_PERMISSIONS.EXAM.QSET.VIEW,
          APP_PERMISSIONS.EXAM.AUDIT_LOG.VIEW,
          APP_PERMISSIONS.EXAM.EXAMINATION_COURSE.VIEW,
        ]}
        options={{ operator: 'OR' }}
      >
        <Outlet />
      </PermissionGuard>
    </ExaminationCourseProvider>
  );
}
